import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { EntityService } from "../services/entity-service";
import { NotifyService } from "../services/notify-service";

RLCreateDataDefault.$inject = ['$compile'];
export function RLCreateDataDefault($compile: ng.ICompileService): ng.IDirective {
	return {
		restrict: 'A',
		replace: true,
		scope: {
			parentCharTypeId: '@',
			charTypeId: '@',
			selectedEntityIds: '=',
			relCharTypeId: '@',
			relChildCharTypeId: '@',
			defaults: '='
		},
		template: '<a href="#" ng-click="cddVM.selectedEntityIds.length == 0 || cddVM.NewDataDefaultSet();">Save as {{cddVM.dataDefaultTitle}}</a>',
		controller: CreateDataDefaultController,
		controllerAs: 'cddVM',
		bindToController: true,
		link: ($scope: ng.IScope, $element: ng.IAugmentedJQuery, $attributes: ng.IAttributes) => {

		}
	}
}

class CreateDataDefaultController {
	static $inject = ['$scope', '$uibModal', 'notifyService', 'entityService'];

	selectedEntityIds: string[];
	dataDefaultTitle: string;
	parentCharTypeId: string;
	charTypeId: string;
	relCharTypeId: number;
	relChildCharTypeId: number;
	defaults: Models.IDataDefaultSet[];

	constructor(
		private $scope: ng.IScope,
		private $uibModal: ng.ui.bootstrap.IModalService,
		private notifyService: NotifyService,
		private entityService: EntityService) {


		this.$scope.$watch(() => this.charTypeId, (newValue) => {
			this.dataDefaultTitle = this.getDataDefaultTitle(this.charTypeId);
		});
	}

	private getDataDefaultTitle(charTypeID: string) {
		switch (parseInt(charTypeID)) {
			case Consts.CharTypeIDs.right: return "Rights Profile"
			case Consts.CharTypeIDs.usage: return "Quick Table"
			default: return "Data Default"
		}
	}

	NewDataDefaultSet() {
		let modal = this.$uibModal.open({
			controller: DataDefaultModalController,
			controllerAs: 'modalVM',
			bindToController: true,
			template: `
					<div class="modal-header">
						<button type="button" class="close" ng-click="modalVM.Cancel()" aria-hidden="true"><i class="fa fa-times"></i></button>
						<h2 class="modal-title">Save ${this.dataDefaultTitle}</h2>
					</div>
					<div class="modal-body form-inline">
						<label for="dataDefaultLabel">Name: </label> <input class="form-control" id="dataDefaultLabel" type="text" ng-model="modalVM.dataDefaultLabel" required />
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-default" ng-click="modalVM.Cancel()">Cancel</button>
						<button type="button" class="btn btn-success" ng-click="modalVM.Save()" ng-disabled="!modalVM.dataDefaultLabel">Save</button>
					</div>`
		}).result;

		modal.then((title) => {
			this.SaveDataDefaultSet(title);
		});
	}

	SaveDataDefaultSet(dataDefaultTitle: string) {
		if (!this.selectedEntityIds.length) {
			alert("Must select items to save");
			return;
		}

		const recIDs = _.map(this.selectedEntityIds, (entityID) => {
			return Utils.IdBuilder.splitEntityID(entityID).recID;
		});

		this.notifyService.startProgress();
		this.entityService.createDataDefaultSet(parseInt(this.parentCharTypeId), parseInt(this.charTypeId), recIDs, dataDefaultTitle,
			this.relCharTypeId, this.relChildCharTypeId)
			.then((res: any) => {
				this.defaults = this.defaults || [];
				this.defaults.push({
					hasConfigurationError: false,
					label: dataDefaultTitle,
					id: res.id.data,
					templateIDs: []
				});
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}
}

class DataDefaultModalController {
	static $inject = ['$uibModalInstance'];

	dataDefaultLabel: string;

	constructor(private $uibModalInstance: ng.ui.bootstrap.IModalServiceInstance) {

	}

	Save() {
		this.$uibModalInstance.close(this.dataDefaultLabel);
	}

	Cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}
}

export function RLViewDataDefaults(): ng.IDirective {
	return {
		restrict: 'E',
		scope: {
			selectedEntities: '='
		},
		template: '',
		controller: ViewDataDefaultsController,
		controllerAs: 'vddVM',
		bindToController: true
	}
}

class ViewDataDefaultsController {
	static $inject = [];
	constructor() {

	}
}
